import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import { getSection, saveSection, updateSection } from './SectionService';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const SectionDetail = (): JSX.Element => {
  const [name, setName] = useState('');
  const [level, setLevel] = useState('');
  const [sequence, setSequence] = useState('');
  const navigate = useNavigate();
  const { sectionid } = useParams<{ sectionid: string }>();
  // const [loading, setLoading] = useState(false);

  function clearSectionDetailsForm() {
    //setProgrammeId('')
    setName('');
    setLevel('');
    setSequence('');
  }

  const cancelSaveOrUpdateSection = () => {
    clearSectionDetailsForm();
    navigate('/system/dashboard/sections');
  };

  function saveOrUpdateSection(e) {
    e.preventDefault();

    const section = { name, level, sequence };

    if (sectionid) {
      const sectionIdAsNumber: number = parseInt(sectionid);
      updateSection(sectionIdAsNumber, section)
        .then(() => {
          navigate('/system/dashboard/sections');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    } else {
      saveSection(section)
        .then(() => {
          navigate('/system/dashboard/sections');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }

  useEffect(() => {
    if (sectionid) {
      const sectionIdAsNumber: number = parseInt(sectionid);
      console.log('sectionid exists: ', sectionid);
      getSection(sectionIdAsNumber)
        .then((response) => {
          console.log(response.data);
          setName(response.data.name);
          setLevel(response.data.level);
          setSequence(response.data.sequence);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [sectionid]);

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/system/dashboard/sections"
            >
              Sections
            </Link>
            <Typography color="text.primary">Section Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Section Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Sequence
                </Typography>
                <TextField
                  variant="outlined"
                  name={'sequence'}
                  fullWidth
                  value={sequence} // Use the 'sequence' state variable as the value
                  onChange={(event) => setSequence(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Name
                </Typography>
                <TextField
                  variant="outlined"
                  name={'name'}
                  fullWidth
                  value={name} // Use the 'name' state variable as the value
                  onChange={(event) => setName(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Level
                </Typography>
                <TextField
                  variant="outlined"
                  name={'level'}
                  fullWidth
                  value={level} // Use the 'sequence' state variable as the value
                  onChange={(event) => setLevel(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  width="100%"
                  marginBottom={4}
                >
                  <Button onClick={cancelSaveOrUpdateSection}>Cancel</Button>
                  <Button
                    onClick={saveOrUpdateSection}
                    variant="contained"
                    color="primary"
                  >
                    Save
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </SystemDashboard>
    </Container>
  );
};

export default SectionDetail;
